export const TYPE_CONTROL = [
    {
        id: 1,
        label: 'mcu.select.auto',
        value: 'auto',
    },
    {
        id: 2,
        label: 'mcu.select.manual',
        value: 'manual',
    },
];

export const TYPE_CALL = [
    {
        id: 1,
        label: 'mcu.select.sip',
        value: 'sip',
    },
    {
        id: 2,
        label: 'mcu.select.h323',
        value: 'h323',
    },
];

export const PIN_LAYOUT_NUMBER = [
    {
        id: 0,
        label: '0',
        value: 0,
    },
    {
        id: 1,
        label: '1',
        value: 1,
    },
    {
        id: 2,
        label: '2',
        value: 2,
    },
    {
        id: 3,
        label: '3',
        value: 3,
    },
    {
        id: 4,
        label: '4',
        value: 4,
    },
];

export const PARTICIPANT_PROPERTY_KEY = {
    MICRO: 'canSpeak',
    CAMERA: 'hasVideo',
    CAN_BE_SEEN: 'canBeSeen',
    SOUND: 'canHear',
    POSITION: 'position',
    MICRO_VOLUME: 'volumeIn',
    SOUND_VOLUME: 'volumeOut',
    CODE: 'code',
    ID: 'id',
    CALLER_NAME: 'callerName'
}

export const ROOM_PROPERTY_KEY = {
    LOCKED: 'locked',
    ROOM_NUMBER: 'roomNumber',
    MUTE_ON_ENTRY: 'muteOnEntry',
    ROOM_NAME: 'roomName'
}

export const CONTROL_PARTICIPANT_TYPE = {
    AMUTE: 'amute',
    UN_AMUTE: 'un-amute',
    DEAF: 'deaf',
    UN_DEAF: 'un-deaf',
    VMUTE: 'vmute',
    UN_VMUTE: 'un-vmute',
    VOLUME_IN: 'volume-in',
    VOLUME_OUT: 'volume-out',
    LOCK: 'lock',
    UN_LOCK: 'unlock'
}

